<script>
import Spinner from '@/components/atoms/Spinner'
import Filters from '@/modules/mixins/filters'
export default {
    name: 'RestaurantsLoader',
    components: {
        Spinner,
    },
    mixins: [Filters],
    props: {
        restaurants: null,
    },

    computed: {
        hasFilters() {
            return (
                this.$route.query.tag_names ||
                this.$route.query.tag_name ||
                Object.entries(this.$route.query).reduce((p, [key, value]) => {
                    const gFilter = this.filters.find((gFilter) => gFilter.key === key)
                    if (value && gFilter) p.push(gFilter)
                    return p
                }, []).length
            )
        },
    },
    methods: {
        clearAllFilters() {
            this.setQuery(
                {
                    ...{
                        tag_names: undefined,
                        tag_name: undefined,
                    },
                    ...this.filters.reduce((p, c) => {
                        p[c.key] = undefined
                        return p
                    }, {}),
                },
                'restaurant-list',
                {
                    pageLoader: false,
                },
                () => {
                    this.$store.dispatch('tags/fetch', this.$route)
                }
            )
        },
    },
}
</script>

<template lang="pug">
.restaurants-loader(:class="{'position-sticky bottom-30': restaurants.delay}")
    transition(:name="'fade'" mode="out-in")
        .d-flex.flex-column.align-items-center(v-if="!restaurants.length && !restaurants.loading && !restaurants.reload && restaurants.loaded")
            h2.my-4.text-center.text-primary {{ $t('restaurant.empty_list') }}
            button.btn.btn-primary(v-if="hasFilters" @click="clearAllFilters") {{$t('base.clear_all_filters')}}
        .d-flex.justify-content-center(
            v-else-if="restaurants.loading || restaurants.delay || (restaurants.reload && !restaurants.length)")
            spinner
</template>
